import {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {useAuth} from '../components/AuthContext';
import {AuthShell, loginDestination} from '../components/AuthShell';
import {Field, Submit, ErrorBox, Loading, Action} from '../components/Common';
import {api, errorMessage} from '../lib/api';

export default function Auth({founder = false}) {
  const {setUser} = useAuth(); const navigate = useNavigate(); const location = useLocation();
  const [busy, setBusy] = useState(false); const [error, setError] = useState('');
  const [mfa, setMfa] = useState(false); const [options, setOptions] = useState(null);
  useEffect(() => {
    setError(''); setMfa(false);
    if (founder) api.get('/auth/options').then(({data}) => setOptions(data)).catch(e => setError(errorMessage(e)));
  }, [founder]);
  async function submit(event) {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const {data} = await api.post('/auth/login', {...Object.fromEntries(new FormData(event.target)), audience: founder ? 'founder' : 'all'});
      if (data.mfa_required) {setMfa(true); return;}
      setUser(data); navigate(loginDestination(data, location.state?.from), {replace: true});
    } catch (failure) {setError(errorMessage(failure));} finally {setBusy(false);}
  }
  const needsSetup = founder && options?.founder_setup_required;
  return <AuthShell eyebrow={founder ? 'FOUNDER ACCESS' : 'INVESTOR ACCOUNT'}
    title={needsSetup ? 'Set up your founder account.' : founder ? 'Founder sign in.' : 'Welcome back.'}
    description={needsSetup ? 'Protect your company workspace with a private setup code and an authenticator.' : founder ? 'Your founder email, password and authenticator code.' : 'Sign in to continue your investor conversation.'}>
    {founder && !options && !error ? <Loading/> : needsSetup ? <div className="founder-setup-entry">
      <p data-testid="founder-setup-required">No founder account has been created yet.</p>
      <Action to="/admin/setup" id="founder-start-setup">Set up founder account</Action>
      <p className="caption" data-testid="founder-setup-security">Only the holder of the private founder setup code can create this account. Public registration never grants founder access.</p>
    </div> : (!founder || options) && <form onSubmit={submit} data-testid="auth-form">
      <Field label="Email address" name="email" type="email" autoComplete="email" required/>
      <Field label="Password" name="password" type="password" autoComplete="current-password" required maxLength={72}/>
      {(mfa || founder) && <Field label="Authenticator code" name="code" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} required={mfa || founder} autoComplete="one-time-code" placeholder="Six-digit code"/>}
      <ErrorBox error={error}/><Submit busy={busy} id="auth-submit">{founder ? 'Sign in as founder' : mfa ? 'Verify & sign in' : 'Sign in'}</Submit>
    </form>}
    {founder && (!options || needsSetup) && <ErrorBox error={error}/>}
    <div className="auth-request">{!founder && <><p data-testid="login-registration-prompt">New to Mahakali Tribunal?</p><Link to="/register" data-testid="login-create-account">Create an investor account <span>↗</span></Link></>}
      <Link to="/accept-invitation" data-testid="login-accept-invitation">Have an invitation? Accept it here <span>↗</span></Link>
      <Link to={founder ? '/login' : '/founder'} data-testid="login-switch-role">{founder ? 'Investor sign in' : 'Founder sign in / setup'} <span>↗</span></Link>
    </div>
  </AuthShell>;
}